import React, { useState } from "react";
import {
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  TextField,
  Paper,
} from "@mui/material";

import InboxTab from "./tabs/InboxTab";
import DashboardTab from "./tabs/DashboardTab";
import SankalanTab from "./tabs/SankalanTab";
import PashukhadyaTab from "./tabs/PashukhadyaTab";
import AdvanceTab from "./tabs/AdvanceTab";
import AIChargesTab from "./tabs/AIChargesTab";
import DepositLedgerTab from "./tabs/DepositLedgerTab";
import OtherAdvance from "./tabs/OtherAdvance";
import BillingTab from "./tabs/BillingTab";
import AushadheTab from "./tabs/AushadheTab";
import MilkProGodhanHealth from "./tabs/MilkProGodhanHealth";
import MilkProOpenMarket from "./tabs/MilkPrOOpenMarket";
import RebatePage from "./tabs/RebatePage";

// Utility function to parse username → companyId, centerId, farmerId
function parseUsername(username) {
  const parts = username.split("-");
  const companyCode = parts[0];
  const centerPart = parts[1] || "";
  const farmerPart = parts[2] || "0";

  const letters = "ABCDEFGHIJ";
  let companyId = 0;
  for (let i = 0; i < companyCode.length; i++) {
    const idx = letters.indexOf(companyCode[i].toUpperCase());
    if (idx !== -1) companyId = companyId * 10 + idx;
  }

  const centerId = parseInt(centerPart.replace(/\D/g, ""), 10) || 0;
  const farmerId = parseInt(farmerPart, 10) || 0;

  return { companyId, centerId, farmerId };
}

export default function PassbookPage() {
  const formatDate = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const defaultFrom = new Date();
  defaultFrom.setDate(today.getDate() - 15);

  const [activeTab, setActiveTab] = useState(0);
  const [fromDate, setFromDate] = useState(formatDate(defaultFrom));
  const [toDate, setToDate] = useState(formatDate(today));

  // Retrieve farmer info from localStorage
  const farmerUsername = localStorage.getItem("farmerUsername") || "";
  const farmerData = JSON.parse(localStorage.getItem("farmerData")) || {};
  const farmerName = farmerData.farmer_name || "उत्पादकाचे नाव";
  const DairyName = farmerData.dairy_name || "डेअरीचे नाव";
  
  // alert(farmerUsername);
  // alert(farmerData.farmerId);
  // alert(farmerData.farmer_name);
  // alert(DairyName.dairy_name);

  const { companyId } = parseUsername(farmerUsername);

  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  // ✅ Decide logo based on companyId
  const logoPath =
    companyId === 89 ? "/assets/logo89.png" : "/assets/logo.png";

  const allTabs = [
    {
      label: "इनबॉक्स",
      component: <InboxTab fromDate={fromDate} toDate={toDate} />,
    },
    {
      label: "बिलिंग",
      component: (
        <BillingTab
          username={farmerUsername}
          fromDate={fromDate}
          toDate={toDate}
        />
      ),
    },

    {
      label: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          डॅशबोर्ड
          <Box
            sx={{
              backgroundColor: "#ff5252",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
              px: 1,
              borderRadius: "10px",
            }}
          >
            New
          </Box>
        </Box>
      ),
      component: (
        <DashboardTab
          farmerUsername={farmerUsername}
          fromDate={fromDate}
          toDate={toDate}
        />
      ),
    },

    {
      label: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          रिबेट 
          <Box
            sx={{
              backgroundColor: "#ff5252",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
              px: 1,
              borderRadius: "10px",
            }}
          >
            New
          </Box>
        </Box>
      ),
      component: (
        <RebatePage
          farmerUsername={farmerUsername}
          fromDate={fromDate}
          toDate={toDate}
        />
      ),
    },

    {
      label: "संकलन",
      component: <SankalanTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "ठेव",
      component: <DepositLedgerTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "औषधे",
      component: <AushadheTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "A.I.",
      component: <AIChargesTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "पशूखाद्य",
      component: <PashukhadyaTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "अॅडव्हान्स",
      component: <AdvanceTab fromDate={fromDate} toDate={toDate} />,
    },
    companyId === 89 && {
      label: "दूध विक्री",
      component: <OtherAdvance fromDate={fromDate} toDate={toDate} />,
    },

  ].filter(Boolean);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: "hsla(153, 81%, 74%, 0.73)",
          backgroundImage:
            "linear-gradient(45deg, #17dddad6, rgba(184, 222, 247, 0.5))",
          backgroundBlendMode: "multiply",
          border: "1px solid #4CAF50",
          borderRadius: 2,
        }}
      >
        {/* ✅ Flexbox header with logo */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            MilkPro - Passbook
          </Typography>
          {/* I want to display logo only if companyId is 89 */}
          {companyId === 89 && (
            <img
              src={logoPath}
              alt="MilkPro Logo"
              style={{ height: "50px", marginLeft: "10px" }}
            />
          )}
          
        </Box>

        <Typography
          variant="h6"
          fontWeight="bold"
          color="text.secondary"
          gutterBottom
        >
          Milk Supplier - Farmer App
        </Typography>

        <Typography variant="body1" fontWeight="bold" gutterBottom>
          उत्पादक: {farmerName}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <TextField
            type="date"
            label="From"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            size="small"
          />
          <TextField
            type="date"
            label="To"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            size="small"
          />
        </Box>
      </Paper>

      <AppBar
        position="static"
        sx={{ backgroundColor: "hsla(239, 73%, 36%, 1.00)" }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {allTabs.map((tab, index) => (
            <Tab key={index} label={tab.label} sx={{ color: "white" }} />
          ))}
        </Tabs>
      </AppBar>

      <Box sx={{ p: 2 }}>{allTabs[activeTab]?.component}</Box>
    </Box>
  );
}
